import React from "react";
import { LANDING } from "@/constants/testIds";

const ActionTakers = ({ onClaim }) => {
  return (
    <section
      data-testid={LANDING.actionTakersSection}
      className="py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-4xl mx-auto">
        <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#FF8200] mb-4">
          🏀 This Offer Is For
        </p>
        <h2 className="text-4xl md:text-6xl font-black tracking-tighter leading-[0.95]">
          Action Takers.{" "}
          <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
            Not sidelines watchers.
          </span>
        </h2>

        <div className="mt-10 space-y-5 text-lg md:text-xl text-zinc-600 leading-relaxed font-medium">
          <p>
            The Spurs aren't waiting until next season.{" "}
            <span className="text-[#0A0A0A] font-bold">Neither should your business.</span>
          </p>
          <p>
            While the city is focused on the Finals, thousands of potential customers
            will be searching for places to eat, shop, celebrate, stay, and spend money.
          </p>
          <p>
            Some businesses will take advantage of the opportunity. Others will watch
            from the sidelines.{" "}
            <span className="text-[#0A0A0A] font-bold">Which one will you be?</span>
          </p>
          <p>
            To ensure every business receives personalized attention,{" "}
            <span className="text-[#0A0A0A] font-bold">only 10 Spurs Finals Cash-In Packages</span>{" "}
            will be accepted. Once all spots are claimed, this offer will be retired.
          </p>
          <p>
            If you're ready to increase visibility, attract more customers, and capitalize
            on one of the biggest moments happening in San Antonio this year, claim your spot now.
          </p>
        </div>

        <button
          type="button"
          onClick={onClaim}
          data-testid={LANDING.actionTakersCta}
          className="mt-12 rounded-full bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-white font-bold px-8 py-4 text-sm md:text-base tracking-wider uppercase transition-all hover:opacity-95 hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-black/10"
        >
          🏀 Claim My Finals Spot
        </button>
      </div>
    </section>
  );
};

export default ActionTakers;
